export default "__VITE_ASSET__XBRY2yxf__"